import { Injectable } from '@angular/core';

import { Observable, iif } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { UserDataService } from '@core/services/user-data/user-data.service';

import { VirtualCardPinParams } from '@pages/product/virtual-cards-opening/_models/virtual-cards.model';
import { VirtualCardsService } from '@pages/product/virtual-cards-opening/_services/virtual-cards.service';

interface ParamsFromDocument {
  id: string;
  docType?: string;
  docModule?: string;
}

@Injectable({ providedIn: 'root' })
export class GetVirtualCardPinCommand {
  readonly ERROR_MESSAGE = 'Не удалось выполнить запрос, попробуйте позже!';

  constructor(
    private readonly userDataService: UserDataService,
    private readonly virtualCardService: VirtualCardsService
  ) {}

  execute(params: ParamsFromDocument): Observable<string> {
    return new Observable((observer) => {
      this.userDataService
        .getClientInfo()
        .pipe(
          map((clientInfo) => clientInfo.unmaskedPhone),
          switchMap((phone) =>
            iif(
              () => Boolean(params.docType) && Boolean(params.docModule),
              this.pinByVirtualCardNumber(phone, params),
              this.pinByProduct(phone, params.id)
            )
          )
        )
        .subscribe(
          (res) => {
            observer.next(`Первые 2 цифры PIN-кода: ${res.partOfPinCode}`);
            observer.complete();
          },
          (error) => {
            observer.error(error);
            observer.complete();
          }
        );
    });
  }

  private pinByVirtualCardNumber(phoneNumber: string, params: ParamsFromDocument) {
    return this.userDataService.getDocById(params.docType, params.id, params.docModule).pipe(
      map((doc: any): VirtualCardPinParams => {
        if (doc && doc.openVirtualCard && doc.openVirtualCard.virtualCardNumber) {
          return {
            cardId: params.id,
            cardMaskNumber: `%${doc.openVirtualCard.virtualCardNumber.match(/\d+/)[0]}%`,
            phoneNumber: '+' + phoneNumber
          };
        }
        throw '';
      }),
      switchMap((request) => this.virtualCardService.getVirtualCardPin(request)),
      map((res) => {
        if (res && res.partOfPinCode) {
          return res;
        }
        throw this.ERROR_MESSAGE;
      })
    );
  }

  private pinByProduct(phoneNumber: string, id: string) {
    const request: VirtualCardPinParams = {
      cardId: id,
      phoneNumber: '+' + phoneNumber
    };

    return this.virtualCardService.getVirtualCardPin(request).pipe(
      map((res) => {
        if (res && res.partOfPinCode) {
          return res;
        }

        throw this.ERROR_MESSAGE;
      })
    );
  }
}
